import { styled } from '@mui/system';
import { Paper, Divider, Typography } from '@mui/material';
import { Preloader } from '#component/preloader';
import PageBar from '#component/general/page-bar';

export const MapWrap = styled('section')(({ theme }) => ({
  height: 'calc(100% - 64px)',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    height: 'calc(100% - 56px)'
  }
}));

export const ContentContainer = styled('div')(() => ({
  display: 'flex',
  margin: 0,
  flexGrow: 2
}));

export const MapContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  alignItems: 'stretch',
  width: '100%',
  margin: theme.spacing(0)
}));

export const MapPreloaderContainer = styled('div')(() => ({
  position: 'absolute',
  left: 0,
  top: 0,
  overflow: 'hidden',
  width: '100%',
  height: '100%'
}));

export const MapPreloader = styled(Preloader)(() => ({
  position: 'absolute',
  zIndex: 1000,
  margin: '-40px 0 0 -40px',
  left: '50%',
  top: '50%'
}));

export const MapPreloaderShadow = styled('div')(() => ({
  opacity: '0.5',
  backgroundColor: 'black',
  height: '100%',
  width: '100%'
}));

export const DevicesListContainer = styled(Paper)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '35%',
  zIndex: 10,
  height: '100%',
  borderRadius: 0,
  overflow: 'hidden auto',
  '&::-webkit-scrollbar-track': {
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
    borderRadius: 10,
    backgroundColor: '#F5F5F5'
  },
  '&::-webkit-scrollbar': {
    width: 8,
    backgroundColor: '#F5F5F5'
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 10,
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
    backgroundColor: '#a0a0a0'
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%'
  },
  [theme.breakpoints.up('md')]: {
    width: '25%'
  },
  [theme.breakpoints.up('lg')]: {
    width: '20%'
  }
}));

export const DevicesListPreloader = styled(Preloader)(() => ({
  width: 80,
  margin: '0 auto 0',
  height: '100%',
  display: 'flex',
  alignItems: 'center'
}));

export const MobileFilterContainer = styled('div')(() => ({
  backgroundColor: '#EEE',
  padding: '20px 10px 10px 10px'
}));

export const SwitcherContainer = styled('div')(() => ({
  gridArea: 'dateRange',
  textAlign: 'right'
}));

export const FilterButtonContainer = styled(PageBar)(({ theme }) => ({
  position: 'sticky',
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: 'auto 160px',
  gridTemplateAreas: '"filter dateRange"',
  gridGap: theme.spacing(1),
  padding: theme.spacing(2, 4, 2, 4),
  width: '100%',
  backgroundColor: '#EEE',
  zIndex: 1100,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 1, 2, 1),
    gridTemplateRows: 'auto auto'
  },
  [theme.breakpoints.down('sm')]: {
    alignItems: 'start',
    gridTemplateColumns: 'auto 216px'
  },
  [theme.breakpoints.down('sm')]: {
    alignItems: 'center',
    gridTemplateAreas: '"sortControl dateRange" "filter filter"',
    gridTemplateColumns: 'auto',
    padding: theme.spacing(3, 1, 2, 1)
  }
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginTop: 4,
  marginBottom: 4,
  backgroundColor: theme.palette.common.white
}));

export const ErrorText = styled(Typography)(({ theme }) => ({
  color: theme.palette.warning.dark
}));
